export const deviceStatuses = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  IN_TRANSIT: 'In Transit',
  SERVICE_REQUIRED: 'Service Required',
}
